module.exports = __webpack_public_path__ + "img/game-development.4453b3df.svg";